/** Primary hire-rate fields shown prominently in add/edit modals. */
export const PRIMARY_HIRE_RATE_FIELDS = new Set(['week_rate', 'day_rate', 'month_rate']);

export function hireRateFieldGroupClass(field) {
  return PRIMARY_HIRE_RATE_FIELDS.has(field)
    ? 'hire-rate-field-primary'
    : 'hire-rate-field-secondary';
}
